module.exports = __webpack_public_path__ + "static/media/Transfer-or-Status-Adjustments.16fefded.png";